/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_None_Of_TheseInputs */

const cs_pm_none_of_these = /** @type {(inputs: Pm_None_Of_TheseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný z nich – přeskočit`)
};

const en_pm_none_of_these = /** @type {(inputs: Pm_None_Of_TheseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None of these – skip`)
};

/**
* | output |
* | --- |
* | "None of these – skip" |
*
* @param {Pm_None_Of_TheseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_none_of_these = /** @type {((inputs?: Pm_None_Of_TheseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_None_Of_TheseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_none_of_these(inputs)
	return cs_pm_none_of_these(inputs)
});